// extracted by mini-css-extract-plugin
export default {"mobile_buttons":"NewCampaign_mobile_buttons__xWy2X","cont":"NewCampaign_cont__BQXvG","SearchCont":"NewCampaign_SearchCont__o2yYP","mobile_header":"NewCampaign_mobile_header__aoUl0"};